// google needs +14155552671 in E.164 format.
import { splitName } from './split-name';
import { normalizePostalCode } from '../util/normalize-postal-code';
import { jwtToken } from '../context';

function normalizePhoneNumber(phoneNumber) {
  phoneNumber = phoneNumber || '';

  // Remove all non-digit characters
  let digits = phoneNumber.replace(/\D/g, '');

  // Prepend country code (assuming US, so '1')
  if (digits.length === 10) {
    digits = '1' + digits;
  }

  // Add '+' prefix to convert to E.164 format
  return '+' + digits;
}

export function sendLeadToParent(
  name,
  address,
  zipCode,
  countryAlpha3,
  countryAlpha2,
  email,
  phone,
  oneTimeToken,
  appt,
  start,
  end,
  startAMPPM,
  endAMPM
) {
  const { firstName, lastName } = splitName(name);
  email = (email || '').toLowerCase().trim();

  // Construct the message object with necessary fields
  const data = {
    email,
    phoneNumber: normalizePhoneNumber(phone),
    firstName,
    lastName,
    street: address || '',
    postalCode: normalizePostalCode(zipCode, countryAlpha3),
    country: countryAlpha2 || 'US',
    oneTimeToken,
    start,
    end,
    startAMPPM,
    endAMPM,
    apiTokenId: jwtToken.apiTokenId
  };
  const type = appt ? 'appointmentSubmission' : 'leadSubmission';
  const message = {
    type,
    data
  };
  jwtToken.lastMessage = message;
  // Send the message to the parent window
  window.parent.postMessage(message, '*');
}

export function sendHearAboutToParent(hearAbout) {
  const type = 'hearAboutSubmission';
  const data = { ...(jwtToken.lastMessage?.data || {}), hearAbout };
  const message = {
    type,
    data
  };
  window.parent.postMessage(message, '*');
}

export function sendEmailToParent(email) {
  const type = 'emailSubmission';
  const data = { email, apiTokenId: jwtToken.apiTokenId };
  const message = {
    type,
    data
  };
  window.parent.postMessage(message, '*');
}
